import { useEffect, useState } from 'react'
import {
  isBcaPaymentVendor,
  isDokuPaymentVendor,
  isSnapPaymentVendor
} from 'Main/paymentVendorTypes'
import BasicInput from 'views/components/Input/BasicInput'
import { formFromConfigQris } from 'Main/Utils'
import { EMPTY_FORM_QRIS_CONFIGS } from 'Main/Constant'


export function QrisConfigModal ({ show, isAdd, config, vendors, submitting, onClose, onSubmit }) {
  const [form, setForm] = useState(EMPTY_FORM_QRIS_CONFIGS)

  // (Re)load the form whenever the modal opens, or a different config is passed in for editing
  useEffect(() => {
    if (show) setForm(formFromConfigQris(config))
  }, [show, config])

  if (!show) return null

  const snapVendors = vendors.filter((vendor) => isSnapPaymentVendor(vendor.enviroment_type))
  const selectedVendor = snapVendors.find((vendor) => String(vendor.id) === form.payment_vendors_id)
  const isBcaVendor = isBcaPaymentVendor(selectedVendor?.enviroment_type)
  const isDokuVendor = isDokuPaymentVendor(selectedVendor?.enviroment_type)

  const setField = (field) => (value) => {
    setForm((f) => ({ ...f, [field]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <>
      <div className="modal-backdrop fade show" onClick={submitting ? undefined : onClose} />
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{isAdd ? 'Add Qris Config' : 'Edit Qris Config'}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={onClose}
                  disabled={submitting}
                />
              </div>

              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <BasicInput label="Name" value={form.name} onChange={setField('name')} />

                <div className="mt-2">
                  <label className="form-label">Vendor Gateway</label>
                  <select
                    className="form-control"
                    value={form.payment_vendors_id}
                    onChange={(e) => setField('payment_vendors_id')(e.target.value)}
                  >
                    <option value="">-- Select Vendor Gateway --</option>
                    {snapVendors.map((pv) => (
                      <option key={pv.id} value={pv.id}>{pv.name} ({pv.enviroment_type})</option>
                    ))}
                  </select>
                </div>

                {selectedVendor && <>
                  <div className="mt-2">
                    <BasicInput
                      label={isBcaVendor ? 'Merchant ID / Group Code' : 'Merchant ID / Client ID'}
                      value={form.client_id}
                      onChange={setField('client_id')}
                    />
                  </div>

                  <div className="mt-2">
                    <BasicInput
                      label={isBcaVendor ? 'NMID (9 digits)' : 'NMID'}
                      value={form.nmid}
                      onChange={setField('nmid')}
                    />
                  </div>

                  {isBcaVendor && <>
                    <div className="mt-2">
                      <BasicInput
                        label="Sub Merchant ID (Partnership, up to 9)"
                        value={form.sub_merchant_id}
                        onChange={setField('sub_merchant_id')}
                      />
                    </div>

                    <div className="mt-2">
                      <BasicInput
                        label="Partner Merchant Type (Partnership, up to 4)"
                        value={form.partner_merchant_type}
                        onChange={setField('partner_merchant_type')}
                      />
                    </div>

                    <div className="mt-2">
                      <BasicInput
                        label="Terminal Location Name (Partnership, up to 25)"
                        value={form.terminal_location_name}
                        onChange={setField('terminal_location_name')}
                      />
                    </div>
                  </>}

                  <div className="mt-2">
                    <BasicInput
                      label={isBcaVendor ? 'Terminal ID (8 characters)' : 'Terminal ID'}
                      value={form.terminal_id}
                      onChange={setField('terminal_id')}
                    />
                  </div>

                  {isDokuVendor && (
                    <div className="mt-2">
                      <BasicInput label="Postal Code" value={form.postal_code} onChange={setField('postal_code')} />
                    </div>
                  )}
                </>}

                <div className="mt-2">
                  <BasicInput label="Description" type="textarea" value={form.description} onChange={setField('description')} />
                </div>

                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="qc_enabled"
                    checked={form.enabled}
                    onChange={(e) => setField('enabled')(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="qc_enabled">Enabled</label>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-light text-black" onClick={onClose} disabled={submitting}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={submitting}>
                  <i className={`fa-solid ${submitting ? 'fa-circle-o-notch fa-spin' : 'fa-floppy-disk'}`} />{' '}
                  {submitting ? 'Saving...' : (isAdd ? 'Add Qris Config' : 'Save Changes')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
